import React, { useState, useEffect } from 'react';
import { createCampaign, fetchAllCampaigns } from '../../api/campaigns';
import { toast } from 'react-toastify';

const CreateCampaignPage = () => {
    const [name, setName] = useState('');
    const [desc, setDesc] = useState('');
    const [minLevel, setMinLevel] = useState('');
    const [prerequisiteCampaignIDs, setPrerequisiteCampaignIDs] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchAllCampaigns()
            .then(setCampaigns)
            .catch(err => console.error('Failed to fetch campaigns:', err));
    }, []);

    const togglePrereq = campaignID => {
        setPrerequisiteCampaignIDs(prev =>
            prev.includes(String(campaignID))
                ? prev.filter(id => id !== String(campaignID))
                : [...prev, String(campaignID)]
        );
    };

    const handleSubmit = async event => {
        event.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const payload = {
                name,
                desc,
                minLevel: minLevel ? Number(minLevel) : null,
                prerequisiteCampaignIDs,
            };
            await createCampaign(payload);
            toast.success('Campaign created successfully!');
        } catch (err) {
            setError('Error creating campaign: ' + err.message);
            toast.error('Error creating campaign: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-page create-campaign-page">
            <h2>Create Campaign</h2>
            {error && <p className="admin-error">{error}</p>}
            <form className="admin-form admin-form--vertical" onSubmit={handleSubmit}>
                <div className="admin-field">
                    <label htmlFor="name">Name</label>
                    <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} required />
                </div>
                <div className="admin-field">
                    <label htmlFor="desc">Description</label>
                    <textarea id="desc" value={desc} onChange={e => setDesc(e.target.value)} required />
                </div>
                <div className="admin-field">
                    <label htmlFor="minLevel">Minimum Level</label>
                    <input id="minLevel" type="number" min="1" value={minLevel} onChange={e => setMinLevel(e.target.value)} placeholder="No requirement" />
                </div>
                {campaigns.length > 0 && (
                    <fieldset className="admin-fieldset">
                        <legend>Prerequisite Campaigns</legend>
                        <div className="prereq-picker__list">
                            {[...campaigns].sort((a, b) => a.name.localeCompare(b.name)).map(c => (
                                <label key={c.campaignID} className="prereq-picker__item">
                                    <input
                                        type="checkbox"
                                        checked={prerequisiteCampaignIDs.includes(String(c.campaignID))}
                                        onChange={() => togglePrereq(c.campaignID)}
                                    />
                                    {c.name}
                                </label>
                            ))}
                        </div>
                    </fieldset>
                )}
                <button type="submit" disabled={loading}>
                    {loading ? 'Creating...' : 'Create Campaign'}
                </button>
            </form>
        </div>
    );
};

export default CreateCampaignPage;
